;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .controller('InputDateController', InputDateController)

  /* @ngInject */
  function InputDateController ($scope, Utils) {
    const api = {
      _checkForLinks
    }
    this.getApi = () => api

    $scope.locale = moment.locale()

    activate()

    function activate () {
      $scope.copyValue = `${$scope.value}`
      $scope.format = $scope.format || 'DD-MM-YYYY'
      $scope.maxView = $scope.maxView || 'month'

      if ($scope.greatThanEqual) {
        $scope.minDate = Utils.getMinDate(Number($scope.greatThanEqual) + 1)
      }

      api._checkForLinks()
    }

    $scope.onChange = function (newValue) {
      if ($scope.change) {
        $scope.change({
          modelPropertyName: $scope.modelPropertyName,
          modelNewValue: newValue
        })
      }
    }

    $scope.clearInput = function () {
      $scope.model = null
      $scope.value = null
      $scope.onChange(null)
    }

    function _checkForLinks () {
      const result = Utils.processTextsWithLinks([$scope.label, $scope.description])
      $scope.labelWithLinks = result[0]
      $scope.descriptionWithLinks = result[1]
    }
  }
})()
